import DotsLoading from '../../../components/dotsLoading';
import HeaderLogo from '../../../components/headerLogo';
import MessageList from '../../../module/message/messages';
import UseGetMessages from '../hooks/useGetMessages';
import EmptyImage from '../../../assets/image/shared/empty_list.svg';
const Home = () => {
  const {isMessagesLoading, messages, isSuccess, refetch} = UseGetMessages();

  return (
    <>
      <HeaderLogo />
      {isSuccess && messages?.results.length === 0 && (
        <div className="d-flex justify-content-center flex-1 alihn-items-center mt-5 pt-5">
          <img src={EmptyImage} alt="در حال حاضر پیامی جهت نمایش موجود نیست" />
        </div>
      )}

      {isMessagesLoading ? (
        <DotsLoading />
      ) : (
        <MessageList refetch={refetch} messages={messages?.results} />
      )}
    </>
  );
};

export default Home;
